
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn-more",
      function () {
        return require("private-next-pages/learn-more.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn-more"])
      });
    }
  